const flagDefaultStyle = theme => ({
  display: 'inline-block',
  fontFamily: theme.tokens.ComponentFlagFontName,
  fontSize: '10px',
  lineHeight: '100%',
  textAlign: 'center',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
  fontWeight: 600,
  boxSizing: 'border-box'
});
export default flagDefaultStyle;